import { render, staticRenderFns } from "./ProductCarouselTrending.vue?vue&type=template&id=204dc936"
import script from "./ProductCarouselTrending.vue?vue&type=script&lang=js"
export * from "./ProductCarouselTrending.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports